import { createSelector } from '@reduxjs/toolkit';
import * as selectors from '../../state/reducer';

export const mapState = createSelector(
  selectors.getCanViewFlock,
  selectors.getCanViewPartner,
  selectors.getCanAccessRogbot,
  selectors.getCanUseTools,
  (canViewFlock, canViewPartner, canUseRogbot, canUseTools) => {
    return {
      canViewFlock,
      canViewPartner,
      canUseRogbot,
      canUseTools,
    };
  }
);
